import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  interfaceData: [],
  destinationTablesData: [],
  mapsData: [],
  selectedInterface: null,
  selectedInterfaceID: null,
  selectedDestinationTable: null,
  selectedDestinationTableID: null,
  selectedInterfaceIDMaps: null,
  selectedDestinationTableIDMaps: null,
  mapDetails: [],
  fieldResource: [],
  uniqueDefinitionsMapsData: [],
  calculationTypesMapsData: [],
  mapDetailsDataPayload: [],
  sourceFieldValidationData: {},
  validating: false,
  isValidPayloadDetails: false,
  page: 0,
  rowsPerPage: 10,
  sort: {
    keytoSort: "modified",
    direction: "desc",
  },
  originalParams: "",
  unifierRawTableData: [],
};

const mapsSlice = createSlice({
  name: "maps",
  initialState: initialState,
  reducers: {
    setInterfaceData: (state, action) => {
      state.interfaceData = action.payload;
    },
    setDestinationTablesData: (state, action) => {
      state.destinationTablesData = action.payload;
    },
    setMapsData: (state, action) => {
      state.mapsData = action.payload;
    },
    setSelectedInterface: (state, action) => {
      state.selectedInterface = action.payload;
    },
    setSelectedInterfaceID: (state, action) => {
      state.selectedInterfaceID = action.payload;
    },
    setSelectedDestinationTable: (state, action) => {
      state.selectedDestinationTable = action.payload;
    },
    setSelectedDestinationTableID: (state, action) => {
      state.selectedDestinationTableID = action.payload;
    },
    setMapDetails: (state, action) => {
      state.mapDetails = action.payload;
    },
    setFieldResource: (state, action) => {
      state.fieldResource = action.payload;
    },
    setPage: (state, action) => {
      state.page = action.payload;
    },
    setRowsPerPage: (state, action) => {
      state.rowsPerPage = action.payload;
    },
    setSort: (state, action) => {
      state.sort = action.payload;
    },
    setOriginalParams: (state, action) => {
      state.originalParams = action.payload;
    },
    setSelectedInterfaceIDMaps: (state, action) => {
      state.selectedInterfaceIDMaps = action.payload;
    },
    setSelectedDestinationTableIDMaps: (state, action) => {
      state.selectedDestinationTableIDMaps = action.payload;
    },
    setCalculationTypesMapsData: (state, action) => {
      state.calculationTypesMapsData = action.payload;
    },
    setUniqueDefinitionsMapsData: (state, action) => {
      state.uniqueDefinitionsMapsData = action.payload;
    },
    setMapDetailsDataPayload: (state, action) => {
      state.mapDetailsDataPayload = action.payload;
    },
    setIsValidPayloadDetails: (state, action) => {
      state.isValidPayloadDetails = action.payload;
    },
    setSourceFieldValidationData: (state, action) => {
      state.sourceFieldValidationData = action.payload;
    },
    setValidating: (state, action) => {
      state.validating = action.payload;
    },
    setUnifierRawTableData: (state, action) => {
      state.unifierRawTableData = action.payload;
    },
  },
});

export const {
  setInterfaceData,
  setDestinationTablesData,
  setMapsData,
  setSelectedInterface,
  setSelectedInterfaceID,
  setSelectedDestinationTable,
  setSelectedDestinationTableID,
  setMapDetails,
  setFieldResource,
  setPage,
  setRowsPerPage,
  setSort,
  setOriginalParams,
  setSelectedInterfaceIDMaps,
  setSelectedDestinationTableIDMaps,
  setCalculationTypesMapsData,
  setUniqueDefinitionsMapsData,
  setMapDetailsDataPayload,
  setIsValidPayloadDetails,
  setSourceFieldValidationData,
  setValidating,
  setUnifierRawTableData,
} = mapsSlice.actions;

export default mapsSlice.reducer;
